<template>
  <el-row>
    <el-dialog
      :title="$t('741')"
      :visible="visible"
      append-to-body
      :close-on-click-modal="false"
      :before-close="handleCancel"
    >
      <!-- 内容 -->
      <div class="select-content">
        <!-- 选择框 -->
        <div class="select-active">
          <!-- 搜索框 -->
          <el-input
            class="search-input"
            prefix-icon="el-icon-search"
            size="small"
            clearable
            v-model="searchKeyword"
            :placeholder="$t('search1')"
            @input="handlerChangeSearch"
          ></el-input>
          <!-- 组织架构 面包屑 -->
          <el-breadcrumb separator-class="el-icon-arrow-right" class="active-bread">
            <el-breadcrumb-item class="active-select" @click.native="handleBreadClick(0, 0)">
              <label>{{ $t('1') }}</label>
            </el-breadcrumb-item>
            <!-- 循环生成面包屑列表 -->
            <el-breadcrumb-item
              v-for="(item, index) in breadcrumb"
              :key="index + 'bre'"
              @click.native="handleBreadClick(item.department_id, index + 1)"
              >{{ item.department_name }}</el-breadcrumb-item
            >
          </el-breadcrumb>
          <!-- 全选 -->
          <el-checkbox class="select-all" v-if="control.all" v-model="selectAll" @change="handlerSelectAll()">{{
            $t('21')
          }}</el-checkbox>
          <!-- 选项操作 -->
          <el-scrollbar class="company" wrap-class="active-content scrollbar-wrapper">
            <ul class="active-list" v-load="loading" :loading-text="$t('989')" v-if="allList.length">
              <li v-for="(item, index) in allList" :key="index + 'left'" class="depart-list">
                <!-- 人员或部门不展示复选框 -->
                <div
                  v-if="(control.depShow === 2 && !item.staff_id) || (item.staff_id && control.staffShow === 2)"
                  class="depart-list-item"
                >
                  <p v-if="item.staff_id">
                    <img
                      class="user-photo"
                      style="vertical-align: middle"
                      :src="item.avatar_url || getAvatar(item.sex || 0)"
                    />
                    {{ item.staff_name_th }}
                    <!-- 在职状态不展示 -->
                    <span :class="item.state === '2' ? 'leave-staff' : 'staff—state'" v-if="handlerState(item)">{{
                      item.state_txt
                    }}</span>
                  </p>
                  <span v-else>{{ item.department_name }}（{{ item.staff_count }}）</span>
                </div>
                <!-- 人员或部门展示复选框 -->
                <el-checkbox
                  v-else
                  v-model="item.isSelect"
                  @change="handlerSelected(item)"
                  :disabled="handleCheck(item, 'check')"
                >
                  <template v-if="item.staff_id">
                    <img
                      class="user-photo"
                      style="vertical-align: middle"
                      :src="item.avatar_url || getAvatar(item.sex || 0)"
                    />
                    <div class="name">
                      <p>
                        <span>{{ item.staff_name_th }}</span>
                        <!-- 在职状态不展示 -->
                        <span :class="item.state === '2' ? 'leave-staff' : 'staff—state'" v-if="handlerState(item)">
                          {{ item.state_txt }}
                        </span>
                      </p>
                      <p class="name_en" v-if="item.staff_name_en">{{ item.staff_name_en }}</p>
                    </div>
                  </template>
                  <div v-else>
                    <img
                      class="user-photo"
                      style="vertical-align: middle"
                      src="@/assets/img/icon_organization.png"
                      alt=""
                    />
                    {{ item.department_name }}
                    （{{ item.staff_count }}）
                  </div>
                </el-checkbox>
                <!-- 打开 -->
                <el-button
                  v-if="!item.staff_id"
                  icon="el-icon-arrow-right"
                  type="text"
                  :disabled="item.isSelect"
                  @click="openChild(item)"
                ></el-button>
              </li>
            </ul>
            <div v-else class="active-list not-data">{{ $t('no_data') }}</div>
          </el-scrollbar>
        </div>
        <!-- 展示框 -->
        <div class="select-show">
          <!-- 控制栏 清空 已选 -->
          <div class="select-show-header">
            <p>{{ $t('prove_3', { x: allSelectedList.length }) }}</p>
            <el-button type="text" @click="handlerClearAll">{{ $t('180') }}</el-button>
          </div>
          <!-- 列表项 -->
          <div class="select-show-list">
            <transition-group name="slide-fade" tag="ul" key="-123">
              <li v-for="(item, index) in allSelectedList" :key="index + 'right'" class="depart-list">
                <!-- 员工 -->
                <template v-if="item.staff_id">
                  <img
                    class="user-photo"
                    style="vertical-align: middle"
                    :src="item.avatar_url || getAvatar(item.sex || 0)"
                  />
                  <div class="name">
                    <p>
                      <span>{{ item.staff_name_th }}</span>
                      <!-- 在职状态不展示 -->
                      <!-- <span :class="item.state === '2' ? 'leave-staff' : 'staff—state'" v-if="handlerState(item)">{{
                        item.state_txt
                      }}</span> -->
                    </p>
                    <p class="name_en" v-if="item.staff_name_en">{{ item.staff_name_en }}</p>
                  </div>
                </template>
                <!-- 判断 部门 or 员工 -->
                <template v-else>
                  <img
                    class="user-photo"
                    style="vertical-align: middle"
                    src="@/assets/img/icon_organization.png"
                    alt=""
                  />
                  <div class="name">
                    <p>
                      <span>{{ item.department_name }}</span>
                    </p>
                  </div>
                </template>
                <!-- 删除当前项 -->
                <el-button
                  v-if="!handleCheck(item, 'button')"
                  icon="el-icon-close"
                  type="text"
                  @click="handlerDel(item, index)"
                ></el-button>
              </li>
            </transition-group>
          </div>
        </div>
      </div>
      <!-- 底部操作栏 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">{{ $t('66') }}</el-button>
        <el-button type="primary" plain @click="doSubmint">{{ $t('131') }}</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import { getCommonDepList, getCommonDepStaff } from 'api/common'
import { getAvatar } from '@/util/util'
import variables from '@/assets/styles/variables.scss'
import { utilCookies } from '@/util/cookies'

export default {
  name: 'oranization',
  props: {
    api: {
      type: Object,
      default: () => {
        return {
          list: getCommonDepList, // 获取列表
          search: getCommonDepStaff // 搜索列表
        }
      }
    },
    visible: {
      type: Boolean, // 弹窗控制
      default: false
    },
    defaultDepatment: {
      type: Array,
      default: () => []
    },
    defaultEmployess: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => {
        return {
          // is_leave: 1 过滤离职人员
          // settlement_type: 1 结算方式为月结
          // data_privilege: 是否限制数据权限 1 限制 0或者不传就是不限制
          // default_select: 默认选中的部门或者人员，1 默认选中部门负责人所在的部门
        }
      }
    },
    control: {
      type: Object,
      default: () => {
        return {
          all: 1, // 是否展示全选
          depShow: 1, // 1部门可选 2 部门不展示复选框 3部门禁用复选框
          staffShow: 1, // 1人员可选 2人员不展示复选框 3人员禁用复选框
          staffMax: null, // 限制选择人员最大个数 只选择人员的时候可使用
          isRegister: null, // 是否添加激活限制
          default_select_dept: false, // true默认选中负责人，且不能删除，false不默认选中
          visible: false // 自己控制弹窗展示关闭 false 当前组建关闭，true父组件控制关闭
        }
      }
    }
  },
  data() {
    const str = utilCookies.getLanguage() || 'en'
    return {
      variables,
      selectAll: false, // 是否全选
      loading: false, // 数据框loading
      breadcrumb: [], // 组织架构面包屑
      currentSelectDepID: 0, // 当前选中部门ID
      dept_list: [], // 部门列表
      staff_list: [], // 员工列表
      // 选中项
      selected: { dept_list: [], staff_list: [] },
      searchKeyword: '', // 搜索内容
      setTimeOutDepList: null,
      lang: str,
      default_select_deptId: [],
      default_select_dept: [] // 接口参数有default_select时 且 control.default_select_dept为true
    }
  },
  created() {
    this.init()
  },
  computed: {
    // 列表项
    allList() {
      return [...this.dept_list, ...this.staff_list]
    },
    // 已选中项
    allSelectedList() {
      return [...this.selected.dept_list, ...this.selected.staff_list]
    }
  },
  watch: {
    visible(v) {
      if (v) {
        const selected = { dept_list: this.defaultDepatment, staff_list: this.defaultEmployess }
        this.selected = JSON.parse(JSON.stringify(selected))
      }
    },
    defaultDepatment: {
      handler(v) {
        const selected = { dept_list: v }
        this.selected.dept_list = JSON.parse(JSON.stringify(selected)).dept_list
      },
      immediate: true,
      deep: true
    },
    defaultEmployess: {
      handler(v) {
        const selected = { staff_list: v }
        this.selected.staff_list = JSON.parse(JSON.stringify(selected)).staff_list
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    init() {
      this.getCommonDepList()
    },
    // 判断全选
    handlerSelectAll() {
      const selected = {}
      if (this.control.depShow === 1) selected.dept_list = []
      if (this.control.staffShow === 1) selected.staff_list = []
      // 选中
      this.allList.forEach(item => {
        const { key } = this.createKey(item)
        if (selected[key]) {
          item.isSelect = this.selectAll
          if (this.selectAll) selected[key].push(item)
        }
      })
      this.selected.dept_list = selected.dept_list || []
      this.selected.staff_list = selected.staff_list || []
    },
    // 生成员工头像姓名
    getAvatar,
    // 获取部门列表
    async getCommonDepList(id) {
      this.loading = true
      const res = await this.api.list({
        department_id: id || this.currentSelectDepID,
        ...this.params
      })
      this.loading = false
      const { dept_list, staff_list, default_select_dept } = res.data
      // 部门列表
      this.dept_list = this.makeSelect(dept_list)
      // 员工列表
      this.staff_list = this.makeSelect(staff_list)
      if (this.control.default_select_dept && default_select_dept.length) {
        this.default_select_deptId = [] // 默认部门负责人所有id
        this.default_select_dept = [] // 默认部门负责人所有数据
        const dept_ids = [] // 已选择部门所有id
        // 获取已选择部门所有id
        this.selected.dept_list.forEach(item => {
          dept_ids.push(item.department_id)
        })
        default_select_dept.forEach(item => {
          // 获取默认部门负责人所有id
          this.default_select_deptId.push(item.department_id)
          // 判断已选择所有部门id中是否存在默认部门id，不存在则选中
          if (!dept_ids.includes(item.department_id)) {
            this.selected.dept_list.push(item)
          }
        })
        // 获取默认部门负责人所有数据
        this.default_select_dept = JSON.parse(JSON.stringify(default_select_dept))
      }
    },
    // 获取key
    createKey(item) {
      const isDept = !item.staff_id ? 0 : 1
      const key = isDept ? 'staff_list' : 'dept_list'
      const indexKey = isDept ? 'staff_id' : 'department_id'
      return { key, indexKey }
    },
    // 生成isSelect字段
    makeSelect(params) {
      if (!Array.isArray(params)) return false
      return params.map(item => {
        const { indexKey } = this.createKey(item)
        const isHas = this.allSelectedList.some(cu => cu[indexKey] === item[indexKey])
        item.isSelect = isHas
        return item
      })
    },
    // 判断已选列表中是否有当前项
    isHasItem(item) {
      const { indexKey } = this.createKey(item)
      return this.allSelectedList.some(current => current[indexKey] === item[indexKey])
    },
    // 是否展示状态
    handlerState(item) {
      return item && item.state && item.state_txt
    },
    handleCheck(item, type) {
      const { depShow, default_select_dept, staffShow } = this.control
      if (item.department_id) {
        // 部门id时，staffShow为3禁用
        if (depShow === 3 && type === 'check') return true
        // 部门id时，default_select_dept为true且默认负责人部门中存在当前部门id禁用
        else if (default_select_dept && this.default_select_deptId.includes(item.department_id)) return true
      } else if (item.staff_id && staffShow === 3 && type === 'check') return true // 个人id时，staffShow为3禁用
      return false
    },
    // 选中状态处理
    handlerSelected(item) {
      const { key, indexKey } = this.createKey(item)
      const status = item.isSelect
      // 是否包含
      const isHas = this.isHasItem(item)
      // 状态为真且不包含
      if (status && !isHas) this.selected[key].push(item)
      // 状态为假且包含
      if (!status && isHas) {
        this.selected[key].map((cu, index) => {
          if (cu[indexKey] === item[indexKey]) this.selected[key].splice(index, 1)
        })
      }
      // 限制选中人员个数
      if (key === 'staff_list' && this.control.staffMax) {
        if (this.selected[key].length > this.control.staffMax) {
          this.selected[key] = this.selected[key].splice(0, this.control.staffMax)
          this.staff_list.forEach(sItem => {
            if (item.staff_id === sItem.staff_id) sItem.isSelect = false
          })
        }
      }
    },
    // 删除选中某一项
    handlerDel(item) {
      const { key, indexKey } = this.createKey(item)
      // 左侧选择栏是否包含当前删除项
      const result = this.allList.filter(cu => cu[indexKey] === item[indexKey])[0]
      // 包含取消选择
      if (result) result.isSelect = false
      this.selected[key].map((cu, index) => {
        if (cu[indexKey] === item[indexKey]) this.selected[key].splice(index, 1)
      })
    },
    // 清空全部 逻辑大概同上
    handlerClearAll() {
      const { default_select_dept } = this.control
      this.allSelectedList.forEach(item => {
        const { indexKey } = this.createKey(item)
        const result = this.allList.filter(cu => cu[indexKey] === item[indexKey])[0]
        if (default_select_dept && item.department_id) {
          // default_select_dept为true且为部门时，在默认负责人部门中存在不取消勾选
          if (!this.default_select_deptId.includes(item.department_id)) {
            if (result) result.isSelect = false
          }
        } else {
          if (result) result.isSelect = false
        }
      })
      this.selected = { dept_list: [], staff_list: [] }
      // default_select_dept为true且为部门时，需要将默认负责人部门选中并在右边展示不能取消
      if (default_select_dept) {
        this.selected.dept_list = this.default_select_dept
      }
    },
    // 面包屑点击处理
    handleBreadClick(id, index) {
      // 请求列表数据
      this.getCommonDepList(id)
      // 删除index之后的面包屑
      this.breadcrumb.splice(index)
    },
    // 展开部门子级菜单
    openChild(params) {
      const id = params.department_id !== undefined ? params.department_id : params.staff_id
      this.getCommonDepList(id)
      this.breadcrumb.push(params)
    },
    // 搜索
    async handlerChangeSearch() {
      this.breadcrumb = []
      this.staff_list = []
      // 搜索框由内容时，调用搜索接口；无内容时调用部门列表
      if (this.searchKeyword) {
        // 激活未激活都需要展示，所以不用传isRegister参数
        const res = await this.api.search({
          search_name: this.searchKeyword,
          ...this.params
        })
        this.staff_list = this.makeSelect(res.data)
      } else {
        this.setTimeOutDepList = this.getCommonDepList()
      }
      this.dept_list = []
    },
    // 取消选择我
    handleCancel() {
      this.$emit('update:visible', false)
    },
    // 提交
    doSubmint() {
      // 总人数
      const staffCount = this.createStaffCount()
      const Ids = this.createIds()
      this.$emit('onConfirm', { ...this.selected, staffCount, ...Ids })
      if (!this.control.visible) this.$emit('update:visible', false)
    },
    // 生成人员总数
    createStaffCount() {
      let { staff_list, dept_list } = this.selected
      staff_list = Array.isArray(staff_list) ? staff_list.length : 0
      let num = 0
      // debugger
      if (Array.isArray(dept_list) && dept_list.length) {
        dept_list.forEach(item => {
          num += item.staff_count || 0
        })
      }
      return staff_list + num
    },
    // 生成Id
    createIds() {
      const { staff_list, dept_list } = this.selected
      return {
        staffIds: staff_list.map(item => item.staff_id),
        depIds: dept_list.map(item => item.department_id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './org.scss';
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  // transform: translateX(10px);
  opacity: 0;
}
.slide-fade-leave-to {
  height: 0;
}
.prompt-text {
  padding: 8px 0;
  color: rgba(0, 0, 0, 0.25);
}
.not-data {
  padding: 20px;
}
.search {
  &-input {
    min-width: 280px;
  }
}
</style>
